export const verify = {
  header1: 'Verify your email address',
  header2:
    'We have sent a 6-digit code to your email address, please enter the code below.',
  adminHeader2: (email) =>
    `Please click the link in your email to verify your Javelin account! We have sent the email to ${
      email || 'your email address'
    }.`,

  goToEmail: 'Go to email',
  return: 'Return to sign in',

  submit: 'Verify',

  errors: {
    required: 'Verification code is required',
  },

  plainText: 'Did not receive code?',
  linkText: 'Request new code',
};

export default {
  verify,
};
